import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { v5 as uuidv5 } from "uuid";
import { NavTreeUpdates } from "./navTreeLookupUtils";
import { AnyChangeLedgerItem } from "@/store/zustand/changeLedgerTypes";

export interface ApplyInstantUpdateProps {
  iframeDocument: Document;
  navTreeUpdates: NavTreeUpdates;
  change: AnyChangeLedgerItem;
  storyboardId: string;
  skipUpdateNavTree: boolean;

  persistentData: {
    // The storyboards that the instant update was applied to
    storyboardsAppliedTo: Set<string>;

    // Extra data about the instant update that is needed to be stored for the undo operation
    instantUpdateData: { [key: string]: any };

    // Whether the instant update failed
    instantUpdateFailed: boolean;
  };
}

/**
 * When a change is applied that references a different codebase id we need to
 * deterministically transform it to the new codebase id. This is done using the
 * codebaseIdHashingKey which is attached to the change object.
 *
 * E.g. if duplicating an element with codebase ID X, the new codebase ID will be
 * transformed to Y using uuidv5(X, codebaseIdHashingKey). All the children will also
 * be transformed to their new codebase IDs using this same codebaseIdHashingKey.
 *
 * This matches the logic in tempo-api
 */
export const updateCodebaseId = (
  codebaseId: string,
  codebaseIdHashingKey: string,
) => {
  const newId = `tempo-${uuidv5(codebaseId, codebaseIdHashingKey)}`;
  const treeElementLookup = useCodebaseStore.getState().treeElementLookup;
  const prevElement = treeElementLookup[codebaseId];
  if (prevElement) {
    treeElementLookup[newId] = prevElement;
    useCodebaseStore.getState().setTreeElementLookup(treeElementLookup);
  }
  return newId;
};
